import { WritableSignal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { prepare } from './prepare.operator';

/**
 * An operator for contextual loading indication without explicitly flipping a loading flag.
 *
 * @param indicator - The subject or signal which holds the boolean state
 */
export function indicate<T>(
  indicator: Subject<boolean> | WritableSignal<boolean>,
): (source: Observable<T>) => Observable<T> {
  return indicator instanceof Subject ? indicateSubject(indicator) : indicateSignal(indicator);
}

function indicateSubject<T>(indicator: Subject<boolean>): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(
      prepare(() => indicator.next(true)),
      finalize(() => indicator.next(false)),
    );
}

function indicateSignal<T>(indicator: WritableSignal<boolean>): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(
      prepare(() => indicator.set(true)),
      finalize(() => indicator.set(false)),
    );
}
